import { API_CONFIG } from "./config/api.config";

// Configuracion de endpoints usando variables de entorno centralizadas.

const getServerUrl = () => {
    if (API_CONFIG.BASE_URL) {
        const apiUrl = API_CONFIG.BASE_URL;
        if ((apiUrl.startsWith('.') || apiUrl.startsWith('/')) && typeof window !== 'undefined') {
            return window.location.origin;
        }
        return apiUrl;
    }

    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

    // 2. Fallbacks seguros solo para desarrollo local
    if (env === 'development' || env === 'dev' || env === 'local') {
        return 'http://localhost:8000';
    }

    console.warn('API URL no esta definida. Usando localhost por defecto.');
    return 'http://localhost:8000';
};

const getFrontendUrl = () => {
    // 1. Variable explícita de Frontend
    if (process.env.REACT_APP_FRONTEND_URL) {
        return process.env.REACT_APP_FRONTEND_URL;
    }

    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

    // 2. Fallbacks seguros solo para desarrollo local
    if (env === 'development' || env === 'dev' || env === 'local') {
        return 'http://localhost:3000';
    }

    // 3. Error si no hay configuración en producción
    console.warn('REACT_APP_FRONTEND_URL no esta definida. Usando localhost por defecto.');
    return 'http://localhost:3000';
};

const getQrHostUrl = () => {
    return 'https://app.almacenia.org';
};
 
const server = getServerUrl();
const frontpagePath = getFrontendUrl();
const qrBase = getQrHostUrl();

export default server;
export const frontpage = frontpagePath;
export const qrBaseUrl = qrBase;
